"use client";

import type * as React from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { appendSearchToPath } from "@/lib/booking/search-params";
import { LucideArrowLeft, LucideCircleArrowLeft } from "lucide-react";
import { Button } from "../ui/button";

type BookingWizardProps = {
  step: 1 | 2 | 3 | 4;
  children: React.ReactNode;
  headerAction?: React.ReactNode;
};

const steps = [
  { label: "Page 1", href: "/booking" },
  { label: "Page 2", href: "/booking/offercheckout" },
  { label: "Page 3", href: "/booking/extras" },
  { label: "Page 4", href: "/booking/confirm" },
] as const;

const stepTitles: Record<BookingWizardProps["step"], string> = {
  1: "Which vehicle do you prefer to drive?",
  2: "Which protection package do you need?",
  3: "Which add-ons do you need?",
  4: "Review your booking",
};

export const BookingWizard: React.FC<BookingWizardProps> = ({
  step,
  children,
  headerAction,
}) => {
  const searchParams = useSearchParams();
  const queryString = searchParams.toString();

  const hrefWithQuery = (href: string) =>
    appendSearchToPath(href, queryString);

  const currentStep = step - 1;
  const previousStep = steps[currentStep - 1];

  return (
    <section className="mx-auto flex flex-col">
      {/* <div className="mb-8 flex w-full items-center justify-center gap-6">
        {steps.map((item, index) => {
          const isActive = index === currentStep;

          return (
            <div
              key={item.href}
              className={`rounded-full px-6 py-3 text-base font-medium ${
                isActive
                  ? "bg-blue-600 text-white"
                  : "bg-zinc-100 text-zinc-600 dark:bg-zinc-900 dark:text-zinc-400"
              }`}
            >
              {item.label}
            </div>
          );
        })}
      </div> */}

      <div className="flex-auto">
        <div className="px-12 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center sticky top-0 z-30">
          <div className="flex items-center gap-1.5">
            {previousStep ? (
            <Link
              href={hrefWithQuery(previousStep.href)}
              className=""
            >
              <LucideArrowLeft size={36}/>
            </Link>
            ) : (
              
              <span></span>
            )}
            <h2 className="text-3xl font-bold">{stepTitles[step]}</h2>
          </div>
          {headerAction ??
            (step !== 1 && step !== 4 ? (
              <Button
                type="submit"
                size="xl"
              >
                Continue
              </Button>
            ) : null)}
        </div>

        {children}

        <div className="mt-auto flex items-center justify-end gap-4">
          {/* {previousStep ? (
            <Link
              href={previousStep.href}
              className="inline-flex min-w-32 items-center justify-center rounded-xl border border-zinc-300 px-7 py-3 text-base font-medium text-foreground transition-colors hover:bg-zinc-100 dark:border-zinc-700 dark:hover:bg-zinc-900"
            >
              Prev
            </Link>
          ) : (
            <span className="inline-flex min-w-32 items-center justify-center rounded-xl border border-zinc-200 px-7 py-3 text-base font-medium text-zinc-400 dark:border-zinc-800">
              Prev
            </span>
          )} */}

          {/* {nextStep ? (
            <Link
              href={nextStep.href}
              className="inline-flex min-w-32 items-center justify-center rounded-xl bg-blue-600 px-7 py-3 text-base font-medium text-white transition-colors hover:bg-blue-700"
            >
              Next
            </Link>
          ) : (
            <span className="inline-flex min-w-32 items-center justify-center rounded-xl bg-zinc-200 px-7 py-3 text-base font-medium text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400">
              Next
            </span>
          )} */}
        </div>
      </div>
    </section>
  );
};
